export enum MainCriterias {
  INVOICE_REF = "Invoice Ref",
  INVOICE = "Invoice",
  CASE = "Case",
  DEBTOR = "Debtor",
  CREDITOR = "Creditor",
}

export enum InvoiceSubCriterias {
  INVOICE_NUMBER = "Invoice Number",
  CASE_NUMBER = "Case Number",
  DEBTOR_NAME = "Debtor Name",
  DEBTOR_NUMBER = "Debtor Number",
  KID = "KID",
  ADDITIONAL_REFERENCE_1 = "ADDITIONAL_REFERENCE_1",
  ADDITIONAL_REFERENCE_2 = "ADDITIONAL_REFERENCE_2",
}

export enum DebtorSubCriterias {
  AR_NUMBER = "AR Number",
  NAME = "Name",
  NUMBER = "Number",
  ADDRESS = "Address",
  TELEPHONE = "Telephone",
  PERSON_NUMBER = "Person Number",
  CASE_NUMBER = "Case Number",
  BIRTHDAY = "Birthday(yyyy/MM/dd)",
  REAL_ESTATE_GNR = "Real Estate GNR",
  REAL_ESTATE_BNR = "Real Estate BNR",
  REAL_ESTATE_SNR = "Real Estate SNR",
  REAL_ESTATE_FNR = "Real Estate FNR",
  EMPLOYER_NUMBER = "Employer Number",
  EMPLOYER_NIN = "Employer NIN",
  DOC_OF_TITLE_SEC_NO = "Document Of Title Section Number",
  VEHICLE_REGISTER_NUMBER = "Vehicle Register Number",
  FINANCIAL_ASSET_NAME = "Financial Asset Name",
}

export const COLEN: string = ":";

export enum CreditorSubCriterias {
  NAME = "Name",
  NUMBER = "Number",
  ADDRESS = "Address",
  GROUP_NUMBER = "Group Number",
  GROUP_NAME = "Group Name",
}

export enum CaseSubCriterias {
  CASE_NUMBER = "Case Number",
  DEBTOR_NUMBER = "Debtor Number",
  DEBTOR_NAME = "Debtor Name",
  KID = "KID",
  INVOICE_NUMBER = "Invoice Number",
  ADDITIONAL_REFERENCE_1 = "ADDITIONAL_REFERENCE_1",
  ADDITIONAL_REFERENCE_2 = "ADDITIONAL_REFERENCE_2",
}

export type CreditorInfo = {
  creditorColor: string;
};
export enum AdditionalReferenceStatus {
  ACTIVE = "active",
  INACTIVE = "inactive",
}
